import React from 'react';
import { IIconProps } from '../interfaces';

const AleaFeature01Icon: React.FC<IIconProps> = ({
  color = '#2B4956',
  size = '25',
  active,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Frame 63" opacity={active ? '1' : '0.5'}>
      <g id="Urine">
        <g id="active">
          <path
            id="Vector"
            d="M5.12973 9.5C3.22987 12.6552 1.5 15.4358 1.5 17.6417C1.5 22.5327 5.30662 26.5 10 26.5C14.6934 26.5 18.5 22.535 18.5 17.6417C18.5 15.4358 16.7701 12.6552 14.8703 9.5H5.12743H5.12973Z"
            fill={color}
          />
          <path
            id="Vector_2"
            d="M18.5 17.6051C18.5 22.5164 14.6934 26.5 10 26.5C5.30662 26.5 1.5 22.5187 1.5 17.6051C1.5 12.6916 10 1.5 10 1.5C10 1.5 18.5 12.6939 18.5 17.6051Z"
            stroke={color}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default AleaFeature01Icon;
